import React, {useRef} from "react"
import {connect} from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import translations from '../../translations';
import Control from "react-leaflet-control";

interface PropsType {
  language: string
}

const GeoMapLegend = (props: PropsType) => {
  const {
    language
  } = props;
  const inputEl: any = useRef(null);


  return language === 'vi' && (
      <Control
          // @ts-ignore
          className="geomap-legend-control first-top-control"
          position="topright"
      >
        <div className="tools-container">
          <div className="geomap-legend-container">
            <div>
              <FontAwesomeIcon
                  className="geomap-legend-icon fa-lg"
                  icon={faInfoCircle}
                  onClick={(event) => {
                    event.preventDefault();
                    // event.stopPropagation();
                    if (inputEl && inputEl.current) {
                      inputEl.current.click()
                    }
                  }}
              />
              <div className="geomap-legend">
                <div className="row">
                  <div className="col-6">
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon polygon"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendPolygon',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon rectangle"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendRectangle',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon circle"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendCircle',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon measure"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendMeasures',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon layers"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendLayers',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon global-view"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendGlobalMapView',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon zoom-in"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendZoomIn',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-icon zoom-out"></span>
                          <span className="geomap-legend-label">{translations('geoMapLegendZoomOut',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Click and drag to draw rectangle:</strong><br/> {translations('geoMapLegendClickAndDragToDrawRectangle',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Release mouse to finish drawing:</strong><br/> {translations('geoMapLegendReleaseMouseToFinishDrawing',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Click to continue drawing shape:</strong><br/> {translations('geoMapLegendClickToContinueDrawingShape',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Click first point to close this shape:</strong><br/> {translations('geoMapLegendClickFirstPointToCloseThisShape',language)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Finish:</strong><br/> {translations('geoMapLegendFinish',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Delete last point:</strong><br/> {translations('geoMapLegendDeleteLastPoint',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Cancel:</strong><br/> {translations('geoMapLegendCancel',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Click and drag to draw circle:</strong><br/> {translations('geoMapLegendClickAndDragToDrawCircle',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Create a new measurement:</strong><br/> {translations('geoMapLegendCreateANewMeasurement',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Start creating a measurement by adding points to the map:</strong><br/> {translations('geoMapLegendStartCreateAMeasurement',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Finish measurement:</strong><br/> {translations('geoMapLegendFinishMeasurement',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Last point:</strong><br/> {translations('geoMapLegendLastPoint',language)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="geomap-legend-row">
                          <span className="geomap-legend-label"><strong>Path distance:</strong><br/> {translations('geoMapLegendPathDistance',language)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Control>
  );
};

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language
});

export default connect(mapStateToProps)(GeoMapLegend);
